/**
 * Map of Ampersend template schema names to
 * template component names
 */
const templateMap = {
  // Desktop Templates
  'MGO Advantage Print Default': 'AdvantagePrintDefault',

  // Mobile Templates
  'MGO Advantage Mobile Full Page Default': 'AdvantageMobileFullPageDefault',
  'MGO Advantage Mobile Full Page Expanded': 'AdvantageMobileFullPageExpanded',
};

/**
 * Get name of template component that corresponds
 * to the Ampersend schema name
 * @param {String} schemaName - name of the Ampersend schema
 * @return {String}
 */
const getComponentBySchemaName = (schemaName) => templateMap[schemaName] || '';

export {
  templateMap,
  getComponentBySchemaName,
};
